// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4341f921","498":"13260c00","703":"11407169"}[chunkId] + ".chunk.js";
};